var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.842 16.5695C19.8762 16.7394 19.893 16.9436 19.893 17.1137V18.3547C19.893 18.5758 19.8762 18.7797 19.825 18.9668C19.6211 19.868 18.873 20.4459 18.0229 20.4459C16.6969 20.4459 15.9488 19.3408 15.9488 17.8277C15.9488 16.2805 16.6969 15.0904 18.0399 15.0904C18.992 15.0904 19.655 15.7535 19.842 16.5695ZM28 8.00002V24C28 26.2 26.2 28 24 28H8.00002C5.8 28 4 26.2 4 24V8.00002C4 5.8 5.8 4 8.00002 4H24C26.2 4 28 5.8 28 8.00002ZM12.0389 10.4831H9.94777V21.942H12.0389V10.4831ZM22.0523 21.942C22.0181 21.3809 21.9842 20.4629 21.9842 19.6129V9.87098H19.893V14.5634H19.859C19.4852 13.9514 18.6689 13.4753 17.5299 13.4753C15.5407 13.4753 13.8066 15.1244 13.8235 17.8957C13.8235 20.4459 15.3876 22.1289 17.3597 22.1289C18.5667 22.1289 19.5699 21.551 20.063 20.6328H20.097L20.182 21.942H22.0523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndesign);
export default __webpack_public_path__ + "static/media/indesign.dc609c15af2828e0f4bc9ab02c780f9f.svg";
export { ForwardRef as ReactComponent };